import {IEvent} from "src/context/models/Event";
import {EVENT_SEVERITY} from "src/common/constants/constants";

export function generateSectionEventsMap(events: IEvent[], region: string): Map<string, IEvent[]> {
    const eventMap: Map<string, IEvent[]> = new Map<string, IEvent[]>();
    events.filter(healthEvent => healthEvent.region == region)
        .forEach(healthEvent => {
            const eventsArr = eventMap.get(healthEvent.section);
            if (eventsArr == undefined) {
                eventMap.set(healthEvent.section, [healthEvent]);
            } else {
                eventsArr.push(healthEvent);
            }
        });
    return eventMap;
}

export function getLatestRunningOpenHealthEvent(sectionEvents: IEvent[] | undefined, operationId: string | null, severity: string) {
    if (!sectionEvents || sectionEvents.length == 0) {
        return undefined;
    }
    // If operationId is present find operation level health status, else return section level
    sectionEvents = sectionEvents.filter(healthEvent => healthEvent.operation == operationId);

    return sectionEvents.filter(healthEvent => healthEvent.eventSeverity == severity)
        //@ts-ignore
        .sort((a, b) => a.lastUpdatedAt - b.lastUpdatedAt)
        .find(healthEvent => (!healthEvent.end));
}

export function getHighestSevOpenEvent(events: IEvent[] | undefined, operationId: string | null) {
    return getLatestRunningOpenHealthEvent(events, operationId, EVENT_SEVERITY.RED)
        || getLatestRunningOpenHealthEvent(events, operationId, EVENT_SEVERITY.YELLOW)
        || getLatestRunningOpenHealthEvent(events, operationId, EVENT_SEVERITY.GREEN_WITH_INFO);
}
